// Importando bibliotecas
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Importação correta

// Importando estilos
import styled from "styled-components";

const Button = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
`;

const GerarPdf = ({ filtrandoCards = [], verQuadro, colunas }) => {

    const opcoesSituacao = {
        AF: "A Fazer",
        PR: "Programado",
        AN: "Em Andamento",
        VA: "Em Validação",
        PA: "Pausado",
        CO: "Concluído",
        CA: "Cancelado",
        AR: "Arquivado",
    };

    const colunasParaImprimir = colunas?.filter(
        (coluna) => coluna.ID_QUADRO === verQuadro?.ID_QUADRO
    );

    const gerarPDF = () => {
        if (!Array.isArray(colunasParaImprimir) || !Array.isArray(filtrandoCards)) {
            console.error("Erro: os dados fornecidos não são arrays.");
            return;
        }

        const doc = new jsPDF({ orientation: "landscape" });
        doc.text(`Relatório: ${verQuadro?.TITULO_QUADRO || "-"}`, 14, 10);
        let startY = 20;

        colunasParaImprimir.forEach((coluna, index) => {
            autoTable(doc, {
                head: [["#", "Descrição da Lista"]],
                body: [[index + 1, coluna.DESCRICAO_LISTA]],
                startY,
                styles: { fillColor: [200, 200, 200] },
            });

            startY = doc.lastAutoTable.finalY;

            const cardsDaColuna = filtrandoCards.filter(card => card.ID_LISTA === coluna.ID_LISTA);

            if (cardsDaColuna.length > 0) {
                const cardsData = cardsDaColuna.map((card, i) => [
                    i + 1,
                    card.TITULO_CARTAO || "-",
                    card.DESCRICAO_CARTAO || "-",
                    opcoesSituacao[card.SITUACAO] || card.SITUACAO || "-", // <-- AQUI está o ajuste
                    card.DATA_CRIACAO || "-",
                    card.DATA_CONCLUSAO || "-",
                    card.NOME_CRIADOR || "-",
                    card.NOME_RESPONSAVEL || "-"
                ]);


                autoTable(doc, {
                    head: [["#", "Título", "Descrição", "Situação", "Criado em", "Concluído em", "Criador", "Responsável"]],
                    body: cardsData,
                    startY,
                });

                startY = doc.lastAutoTable.finalY + 10;
            } else {
                doc.text("Nenhum cartão para esta lista.", 14, startY + 5);
                startY += 10;
            }
        });

        // Contagem por status
        const statusContagem = {};
        filtrandoCards.forEach(card => {
            const status = card.SITUACAO || "Não definido";
            statusContagem[status] = (statusContagem[status] || 0) + 1;
        });

        doc.setFontSize(12);
        doc.text("Resumo por Situação:", 14, startY + 5);

        let y = startY + 12;
        Object.entries(statusContagem).forEach(([status, count]) => {
            const statusLegivel = opcoesSituacao[status] || status;
            doc.text(`${statusLegivel}: ${count}`, 14, y);
            y += 7;
        });


        doc.text(`Total de cartões: ${filtrandoCards.length}`, 14, y + 5);
        window.open(doc.output('bloburl'), '_blank');
    };

    return <Button onClick={gerarPDF}>PDF</Button>;
};

export default GerarPdf;
